export enum RoleEnum {
  DistributorUser = "DistributorUser",
  DistributorAdmin = "DistributorAdmin",
  DistributorSuperAdmin = "DistributorSuperAdmin",
  ShipcoUser = "ShipcoUser",
  ShipcoGroupUser = "ShipcoGroupUser",
  VesselUser = "VesselUser",
}
